import React, { useState, useMemo, useEffect } from "react";
import Link from "next/link";
import { Container, Button, ButtonGroup, Col, Dropdown, Row } from "react-bootstrap";
import SearchArticleInput from "../../components/articleBlock/searchArticleInput";
import RecentTweets from "../../components/recentTweets/recentTweets";
import MainLayout from "../../components/MainLayout/MainLayout";
import twitter from "../../assets/images/twitter.png";
import tikTok from "../../assets/images/tikTok.png";
import broadcast from "../../assets/images/broadcast.png";
import client from "../../components/contentful/Contentful";
import ReactPaginate from "react-paginate";
import BlogCard from "../../components/contentfulBlogs/BlogCard";
import Head from "next/head";
import { useRouter } from "next/router";
import { renderOptions } from "../blog/[...post]";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import Image from "next/image";
import { appServerSideProps } from "../../utils/getAppService";

const Author = ({ blogs, authorDetails, author, user }) => {
  const router = useRouter();
  const [posts, setPosts] = useState(blogs);
  const [activeTab, setActiveTab] = useState("All Categories");
  const recordsPerPage = 12;
  const [pageCount, setPageCount] = useState(0);
  const [startItemIndex, setStartItemIndex] = useState(0);
  const currentItems = useMemo(() => {
    if (posts !== undefined && posts.length !== 0) {
      setPageCount(Math.ceil(posts.length / recordsPerPage));
      const endItemIndex = startItemIndex + recordsPerPage;
      return posts.slice(startItemIndex, endItemIndex);
    } else {
      return posts;
    }
  }, [posts, startItemIndex]);

  const handlePageClick = (event) => {
    const newStartIndex = (event.selected * recordsPerPage) % posts.length;
    setStartItemIndex(newStartIndex);
  };

  const handleNext = () => {
    if (startItemIndex + recordsPerPage < posts.length) {
      setStartItemIndex(startItemIndex + recordsPerPage);
    }
  };
  const handlePrev = () => {
    if (startItemIndex - recordsPerPage >= 0) {
      setStartItemIndex(startItemIndex - recordsPerPage);
    }
  };
  useEffect(() => {
    if (activeTab === "NCAA Basketball Analysis") {
      // router.push("/blog/ncaa-basketball-analysis");
      setPosts(blogs.filter((blog) => blog.metadata.tags[0]?.sys.id.includes("NCAA")));
    } else if (activeTab === "Picks & Predictions") {
      // router.push("/blog/ncaa-picks-and-predictions");
      setPosts(blogs.filter((blog) => blog.metadata.tags[0]?.sys.id.includes("picks")));
    } else {
      setPosts(blogs);
    }
  }, [activeTab]);
  return (
    <>
      <Head>
        <title>{author} | Basketball Analysis</title>
        <meta name="description" content={authorDetails.authorBio?.content[0]?.content[0]?.value} />
        <meta property="og:title" content={author + " | Basketball Analysis"} />
        <meta property="og:description" content={authorDetails.authorBio?.content[0]?.content[0]?.value} />
        <meta property="og:image" content={`https:${authorDetails.authorImage?.fields.file.url}`} />
        <meta property="og:url" content={`https://shotqualitybets.com/blog/${author}`} />
      </Head>
      <MainLayout>
        <Container style={{ maxWidth: "1320px" }}>
          <Row style={{ paddingTop: "50px" }}>
            <Col md={10}>
              <h1>ShotQuality Wire </h1>
            </Col>
            <Col md={2} style={{ display: "flex", justifyContent: "space-between" }}>
              <div style={{ width: "34px", height: "34px" }}>
                <Link href="https://twitter.com/shotqualitybets?lang=en" target={"blank"}>
                  <img src={twitter.src} className="SocialIconImg" alt="Twitter" />
                </Link>
              </div>
              <div style={{ width: "34px", height: "34px" }}>
                <Link href="https://www.tiktok.com/@shotqualitybets" target={"blank"}>
                  <img src={tikTok.src} className="SocialIconImg" alt="TikTok" />
                </Link>
              </div>
              <div style={{ width: "34px", height: "34px" }}>
                <Link href="https://podcasts.apple.com/us/podcast/shotquality-bets/id1657213908" target={"blank"}>
                  <img src={broadcast.src} className="SocialIconImg" alt="Apple Podcast" />
                </Link>
              </div>
            </Col>
          </Row>
          <div className="row pb-4 pt-4 mt-4" style={{ boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px" }}>
            <div className="col-sm-12 col-md-1">
              <Image
                src={"https:" + authorDetails.authorImage?.fields.file.url}
                width={"0"}
                height={"0"}
                layout="responsive"
                alt="Profile"
                style={{ borderRadius: "50%" }}
              />
            </div>
            <div className="col-sm-12 col-md-11">
              <h2>{authorDetails.name}</h2>
              <div>{documentToReactComponents(authorDetails.authorBio, renderOptions)}</div>
            </div>
          </div>
          <Row style={{ marginTop: "40px", paddingBottom: "25px" }}>
            <Col md={8} sm={8} xs={8}>
              <Dropdown className="hide-desktop">
                <Dropdown.Toggle style={{ color: "black" }} id="dropdown-basic">
                  {activeTab}
                </Dropdown.Toggle>
                <Dropdown.Menu style={{ backgroundColor: "black" }}>
                  <ButtonGroup style={{ flexDirection: "column" }}>
                    <Button
                      onClick={(e) => setActiveTab(e.target.value)}
                      style={{ color: "white", margin: 0 }}
                      value={"All Categories"}
                    >
                      All Categories
                    </Button>
                    <Button
                      onClick={(e) => setActiveTab(e.target.value)}
                      style={{ color: "white", margin: 0 }}
                      value={"NCAA Basketball Analysis"}
                    >
                      NCAA Basketball Analysis
                    </Button>
                    <Button
                      onClick={(e) => setActiveTab(e.target.value)}
                      style={{ color: "white", margin: 0 }}
                      value={"Picks & Predictions"}
                    >
                      Picks & Predictions
                    </Button>
                  </ButtonGroup>
                </Dropdown.Menu>
              </Dropdown>
              <div className="list-tab">
                <button
                  onClick={() => setActiveTab("All Categories")}
                  className={`list-item ${activeTab === "All Categories" ? "active" : ""}`}
                >
                  All Categories
                </button>
                <button
                  onClick={() => setActiveTab("NCAA Basketball Analysis")}
                  className={`list-item ${activeTab === "NCAA Basketball Analysis" ? "active" : ""}`}
                >
                  NCAA Basketball Analysis
                </button>
                <button
                  onClick={() => setActiveTab("Picks & Predictions")}
                  className={`list-item ${activeTab === "Picks & Predictions" ? "active" : ""}`}
                >
                  Picks & Predictions
                </button>
              </div>
            </Col>
            <Col md={4}>
              {posts.length > 0 && (
                <SearchArticleInput
                  allCategories={posts}
                  bestBetsPosts={[]}
                  weeklyRecapsPosts={[]}
                  SQBetsPodcastPosts={[]}
                  coachingPhilosophyPosts={[]}
                  collegeMensPosts={[]}
                  collegeWomens={[]}
                  nbaDraftPosts={[]}
                  bettingAnalysisPosts={[]}
                />
              )}
            </Col>
          </Row>
        </Container>
        <Container>
          <div className="row mb-3">
            {currentItems.length > 0 ? (
              currentItems.map((post, index) => (
                <div key={"blog" + index} className="col-lg-4 col-md-6 col-sm-12 pb-5">
                  <BlogCard
                    post={post}
                    isFromHomePage="blog"
                    user={user}
                    source={
                      activeTab === "NCAA Basketball Analysis"
                        ? "NCAA"
                        : activeTab === "Picks & Predictions"
                        ? "picks"
                        : ""
                    }
                  />
                </div>
              ))
            ) : (
              <h5>No Blogs Found</h5>
            )}
          </div>
          {posts?.length > recordsPerPage && (
            <>
              <div className="hidden">
                <ReactPaginate
                  className="articlePagination"
                  activeClassName="activePage"
                  breakLabel="..."
                  nextLabel=">"
                  onPageChange={handlePageClick}
                  pageRangeDisplayed={0}
                  pageCount={pageCount}
                  previousLabel="<"
                  renderOnZeroPageCount={null}
                />
              </div>
              <div className="float-right">
                <button className="btn btn-primary mr-3" disabled={startItemIndex == 0} onClick={handlePrev}>
                  Prev
                </button>
                <button
                  className="btn btn-primary"
                  disabled={startItemIndex + recordsPerPage > posts.length}
                  onClick={handleNext}
                >
                  Next
                </button>
              </div>
            </>
          )}
        </Container>
        <Container fluid style={{ maxWidth: "1320px", padding: "0", backgroundColor: "#F2F4F6" }}>
          <RecentTweets />
        </Container>
      </MainLayout>
    </>
  );
};

export const getServerSideProps = appServerSideProps(async ({ appService, cookies, params, query }) => {
  // export async function getServerSideProps({ params }) {
  const res = await client.getEntries({
    content_type: "blog",
    "fields.targetSite[in]": "ShotQualityBets",
    order: "-fields.published",
  });
  const author = params.author.join("/");
  let blogs = res.items.filter((item) => item.fields.blogAuthor.fields.name === author);
  const authorDetails = blogs[0].fields.blogAuthor.fields;
  if (!blogs.length) {
    return {
      redirect: {
        destination: "/blog",
        permanent: false,
      },
    };
  }

  const isUserLogged = appService.getUser();
  let user = null;
  if (isUserLogged) {
    user = await appService.get("api/account");
  }

  return {
    props: {
      authorDetails,
      blogs: blogs,
      author: author,
      user: user,
    },
  };
});
export default Author;
